import React from 'react';
import Amplify from 'aws-amplify';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withAlert } from 'react-alert';
import { getPageData } from '../../Actions/actions';
import * as SecretKeys from '../../ENV.json';
import Header from '../Header/header';

Amplify.configure(SecretKeys.awsUserpool);

class ResetPasswordMobile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentDidMount() {

  }

  componentDidUpdate() {
    // window.location =  'collectively://resetpassword/';
    window.location.href = 'collectively://resetpassword/';
  }

  render() {
    return (
      <span>
        <Header />
        <div className="section-content left-align term">
          <div className="row">
            <div className="col s12 m10 offset-m1">
              <div className="row">
                <div className="col s12" />
              </div>
            </div>
          </div>
        </div>
      </span>
    );
  }
}

const mapStateToProps = state => ({ data: state.data });

const mapDispatchToProps = dispatch =>
  bindActionCreators({ getPageData }, dispatch);

export default withAlert(connect(mapStateToProps, mapDispatchToProps)(ResetPasswordMobile));
